__turbopack_context__.v({
  "body": "CollectionCard-module__db2U8W__body",
  "description": "CollectionCard-module__db2U8W__description",
  "detailsContainer": "CollectionCard-module__db2U8W__detailsContainer",
  "fileType": "CollectionCard-module__db2U8W__fileType",
  "gradientBox": "CollectionCard-module__db2U8W__gradientBox",
  "image": "CollectionCard-module__db2U8W__image",
  "imageWrapper": "CollectionCard-module__db2U8W__imageWrapper",
  "inscriptionContainer": "CollectionCard-module__db2U8W__inscriptionContainer",
  "inscritions": "CollectionCard-module__db2U8W__inscritions",
  "punks": "CollectionCard-module__db2U8W__punks",
  "root": "CollectionCard-module__db2U8W__root",
  "sponsored": "CollectionCard-module__db2U8W__sponsored",
  "supply": "CollectionCard-module__db2U8W__supply",
  "supplyContainer": "CollectionCard-module__db2U8W__supplyContainer",
  "title": "CollectionCard-module__db2U8W__title",
});
